module.exports = __webpack_public_path__ + "media/images/lb/672-5c1401874a05faee083d5112baf92e73.svg";